import React from 'react';
import PropTypes from 'prop-types';
import {Select} from 'antd';

const Branch = ({branches, selectedBranchUuId, onChange}) => {
    return (
        <Select size={'large'}
                defaultValue={selectedBranchUuId} onChange={onChange} style={{width: '100%'}}>
            {branches.map(branch => (
                <Select.Option key={branch.uuId} value={branch.uuId}>{branch.name}</Select.Option>
            ))}
        </Select>
    )
};

Branch.propTypes = {
    branches: PropTypes.array.isRequired,
    selectedBranchUuId: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default Branch;